<template>
  <div id="loadingRoot">
  <div class="dotCon">
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
    <div class="dot"></div>
  </div>
</div>
 </template>
 
 <script>
  export default {
    data () {
      return {
         
      }
    },
    components: {

    },
    methods:{
      
    }
  }
 </script>
 
 <style>
#loadingRoot{
    /* display: none; */
    width: 100%;
    height: 100%;
    position: fixed;
    text-align: center;
    top: 0;
    left: 0;
    background: rgba(51,51,51,0.5);
    z-index: 1133;
    justify-content: center; /*水平居中*/
    align-items: Center; /*垂直居中*/
  }
  /* #loadingContainer{
    width: 300px;
    height: 300px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    z-index: 1155;
    border-radius: 10px 10px 10px 10px;
  } */

.dotCon {
  width: 40px;
  height: 40px;
  position: relative;
  top: 50%;
  left: 50%;
  z-index: 1155;
  animation: dotCon 2.5s infinite linear both;
}

.dot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: dot 2s infinite ease-in-out both;
}

.dot:before {
  content: "";
  display: block;
  width: 25%;
  height: 25%;
  background-color: #fff;
  border-radius: 100%;
  animation: dot-before 2s infinite ease-in-out both;
}

.dot:nth-child(1) {
  animation-delay: -1.1s;
}
.dot:nth-child(2) {
  animation-delay: -1s;
}
.dot:nth-child(3) {
  animation-delay: -0.9s;
}
.dot:nth-child(4) {
  animation-delay: -0.8s;
}
.dot:nth-child(5) {
  animation-delay: -0.7s;
}
.dot:nth-child(6) {
  animation-delay: -0.6s;
}
.dot:nth-child(1):before {
  animation-delay: -1.1s;
}
.dot:nth-child(2):before {
  animation-delay: -1s;
}
.dot:nth-child(3):before {
  animation-delay: -0.9s;
}
.dot:nth-child(4):before {
  animation-delay: -0.8s;
}
.dot:nth-child(5):before {
  animation-delay: -0.7s;
}
.dot:nth-child(6):before {
  animation-delay: -0.6s;
}

@keyframes dotCon {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dot {
  80%,
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dot-before {
  50% {
    transform: scale(0.4);
  }
  100%,
  0% {
    transform: scale(1);
  }
}
 </style>


// WEBPACK FOOTER //
// src/views/loading/Loading.vue